import { render } from "./UnitCategories.vue?vue&type=template&id=4d7e3a22&scoped=true"
import script from "./UnitCategories.vue?vue&type=script&lang=js"
export * from "./UnitCategories.vue?vue&type=script&lang=js"

import "./UnitCategories.vue?vue&type=style&index=0&id=4d7e3a22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7e3a22"]])

export default __exports__